module.exports = __webpack_public_path__ + "r-v3/img/ico_upload_white.d7650661.svg";